var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOm = function SvgOm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M0 0h640v480H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#ef2d29",
    d: "M-3.3-21.61h702.27v553.02H-3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#009025",
    d: "M174.57 317.33h535.76v207.56H174.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#fff",
    d: "M174.57-35.415h564.88v190.08H174.57z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.983,
    stroke: "#ef2d28"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "matrix(.2 0 0 .2 111.3 -13.4)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 11.298,
    ry: 11.851,
    height: 85.039,
    width: 138.19,
    y: 467.72,
    x: 17.717,
    strokeWidth: 1.406
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 10.719,
    ry: 10.864,
    height: 77.953,
    width: 131.1,
    y: 471.26,
    x: 21.26,
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.966 396.07l9.723.443.44 5.745 7.956 5.303 6.187-6.628 7.513 5.303-7.07 5.746 1.767 7.956 8.838-.442V430.1l-7.07-.44-3.535 6.628 7.955 7.513-6.187 6.188-6.63-6.63-9.722 2.653.443 9.724-10.607.884-1.326-9.28-8.84-4.863-4.86 6.63-7.514-4.862 4.42-7.513-5.304-4.862H34.03l-.442-13.7 7.513.884 5.305-7.955-6.187-6.187 7.955-7.07 5.745 5.744 9.723-1.768 1.327-5.746z",
    transform: "matrix(.7 0 0 .6 38 260.7)",
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.7 0 0 .7 38.8 209.6)",
    cx: 68.944,
    rx: 11.049,
    cy: 426.78,
    ry: 9.944,
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.976 474.8l-10.63 10.63m17.717-10.63l-10.63 10.63M53.15 474.8l-10.63 10.63m17.716-10.63l-10.63 10.63m17.716-10.63l-10.63 10.63M74.41 474.8l-10.63 10.63m17.716-10.63l-10.63 10.63m17.716-10.63l-10.63 10.63M95.67 474.8l-10.63 10.63m17.715-10.63l-10.63 10.63m17.717-10.63l-10.63 10.63m17.717-10.63l-10.63 10.63M88.58 474.8l-10.63 10.63m46.063-10.63l-10.63 10.63M131.1 474.8l-10.63 10.63m17.717-10.63l-10.63 10.63m17.716-10.63l-10.63 10.63m-.002-10.63l10.63 10.63m-17.71-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m-17.71-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m-17.71-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m-17.71-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m17.72-10.63l10.63 10.63M49.607 474.8l10.63 10.63M42.52 474.8l10.63 10.63M35.434 474.8l10.63 10.63M28.347 474.8l10.63 10.63m-.001 49.606l-10.63 10.63m17.717-10.63l-10.63 10.63m17.716-10.63l-10.63 10.63m17.716-10.63l-10.63 10.63m17.716-10.63l-10.63 10.63m17.717-10.63l-10.63 10.63m17.716-10.63l-10.63 10.63m17.716-10.63l-10.63 10.63m17.717-10.63l-10.63 10.63m17.715-10.63l-10.63 10.63m17.717-10.63l-10.63 10.63m17.717-10.63l-10.63 10.63m-17.718-10.63l-10.63 10.63m46.063-10.63l-10.63 10.63m17.717-10.63l-10.63 10.63m17.717-10.63l-10.63 10.63m17.716-10.63l-10.63 10.63m-.002-10.63l10.63 10.63m-17.71-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m-17.71-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m-17.71-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m-17.71-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m17.72-10.63l10.63 10.63m-46.067-10.63l10.63 10.63m-17.717-10.63l10.63 10.63m-17.716-10.63l10.63 10.63m-17.717-10.63l10.63 10.63",
    strokeWidth: 1.311
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    fill: "#fff",
    transform: "matrix(.2 0 0 .2 19.1 -14.1)"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 11.298,
    ry: 11.851,
    height: 85.039,
    width: 138.19,
    y: 467.72,
    x: 17.717,
    strokeWidth: 1.406
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 10.719,
    ry: 10.864,
    height: 77.953,
    width: 131.1,
    y: 471.26,
    x: 21.26,
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.966 396.07l9.723.443.44 5.745 7.956 5.303 6.187-6.628 7.513 5.303-7.07 5.746 1.767 7.956 8.838-.442V430.1l-7.07-.44-3.535 6.628 7.955 7.513-6.187 6.188-6.63-6.63-9.722 2.653.443 9.724-10.607.884-1.326-9.28-8.84-4.863-4.86 6.63-7.514-4.862 4.42-7.513-5.304-4.862H34.03l-.442-13.7 7.513.884 5.305-7.955-6.187-6.187 7.955-7.07 5.745 5.744 9.723-1.768 1.327-5.746z",
    transform: "matrix(.7 0 0 .6 38 260.7)",
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.7 0 0 .7 38.8 209.6)",
    cx: 68.944,
    rx: 11.049,
    cy: 426.78,
    ry: 9.944,
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.976 474.8l-10.63 10.63m17.717-10.63l-10.63 10.63M53.15 474.8l-10.63 10.63m17.716-10.63l-10.63 10.63m17.716-10.63l-10.63 10.63M74.41 474.8l-10.63 10.63m17.716-10.63l-10.63 10.63m17.716-10.63l-10.63 10.63M95.67 474.8l-10.63 10.63m17.715-10.63l-10.63 10.63m17.717-10.63l-10.63 10.63m17.717-10.63l-10.63 10.63M88.58 474.8l-10.63 10.63m46.063-10.63l-10.63 10.63M131.1 474.8l-10.63 10.63m17.717-10.63l-10.63 10.63m17.716-10.63l-10.63 10.63m-.002-10.63l10.63 10.63m-17.71-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m-17.71-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m-17.71-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m-17.71-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m17.72-10.63l10.63 10.63M49.607 474.8l10.63 10.63M42.52 474.8l10.63 10.63M35.434 474.8l10.63 10.63M28.347 474.8l10.63 10.63m-.001 49.606l-10.63 10.63m17.717-10.63l-10.63 10.63m17.716-10.63l-10.63 10.63m17.716-10.63l-10.63 10.63m17.716-10.63l-10.63 10.63m17.717-10.63l-10.63 10.63m17.716-10.63l-10.63 10.63m17.716-10.63l-10.63 10.63m17.717-10.63l-10.63 10.63m17.715-10.63l-10.63 10.63m17.717-10.63l-10.63 10.63m17.717-10.63l-10.63 10.63m-17.718-10.63l-10.63 10.63m46.063-10.63l-10.63 10.63m17.717-10.63l-10.63 10.63m17.717-10.63l-10.63 10.63m17.716-10.63l-10.63 10.63m-.002-10.63l10.63 10.63m-17.71-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m-17.71-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m-17.71-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m-17.71-10.63l10.63 10.63m-17.72-10.63l10.63 10.63m17.72-10.63l10.63 10.63m-46.067-10.63l10.63 10.63m-17.717-10.63l10.63 10.63m-17.716-10.63l10.63 10.63m-17.717-10.63l10.63 10.63",
    strokeWidth: 1.311
  })), /*#__PURE__*/React.createElement("path", {
    d: "M538.58 531.5c1.717 166.56 24.803 201.97 3.543 201.97s-31.89-92.07-31.89-205.51 14.173-205.51 35.433-205.51-8.913 31.91-7.086 209.06z",
    fillRule: "evenodd",
    transform: "matrix(-.3 -.1 -.2 .2 345.9 61.4)",
    strokeWidth: 1.311,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.066 142.506l12.047 3.543c-11.338 12.047-24.094 17.008-27.638 14.882-3.543-2.126 6.378-7.087 15.59-18.425z",
    fillRule: "evenodd",
    strokeWidth: 0.24580000000000002,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.346 149.28l10.185 2.948c-11.338 12.047-22.554 15.477-25.456 14.003-2.918-1.474 6.058-5.613 15.27-16.951z",
    fillRule: "evenodd",
    strokeWidth: 0.254,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.687 83.823c-.019.127-.075.707-.125.938 0 .318-.029.563-.063.812-.08.218-.065.42-.312.5-.17.263-.276.331-.5.438a2.773 2.773 0 0 1-.625.375c-.25.107-.477.121-.75.062-.219-.152-.38-.31-.563-.437-.042-.198-.082-.49-.124-.688.067.203.114.527.124.813-.023.312-.126.448-.25.687M85.962 87.873l-.063-.063c.149.149.088.078-.25-.124-.242-.125-.501-.191-.812-.25h-.875c-.34 0-.57.05-.813.124-.176.177-.439.277-.624.438-.191.13-.273.283-.376.5-.17.17-.28.433-.437.563-.07.286-.214.277-.313.5.295.022.532.062.688.25.26.134-.218-.132-.313-.25-.204-.062-.257-.126-.562-.126-.285-.09-.458.074-.75.126-.17.098-.218.124-.438.124M83.187 90.686c-.127.007-.708.115-.938 0-.255-.07-.406-.204-.562-.438-.077-.168 0 .3 0 .5-.029.369-.137.372-.313.626-.181.116-.372.28-.562.375-.158.136-.352.228-.563.312-.19.09-.41.181-.562.313-.21.149-.19.327-.313.562.024.306.073.479.25.625.074.211.24.42.375.563.155.287.326.422-.062.5-.214.09-.333.02-.563 0M79.337 94.973a14.423 14.423 0 0 1-.938-.313h-.874c-.34.027-.404.126-.688.25-.183.188-.31.317-.563.438-.134.174-.395.468-.5.688a2.548 2.548 0 0 0-.125.812c.005.365.1.427.125.75.07.269.184.515.375.75.027.08.046.099.125.125",
    strokeWidth: 0.1751,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.687 120.598c-.037 0-.12.202-.25.375-.283.29-.32.313-.75.313-.388-.015-.352-.154-.625-.25-.129-.201-.29-.36-.438-.626-.1-.163-.189-.412-.312-.562-.114-.185-.256-.325-.375-.5-.117-.05-.162-.098-.313-.125.36.058.392.187.625.375.11.178.219.363.313.563.036.267.121.477.125.812 0 .346-.002.587-.125.875-.147.154-.256.314-.438.438-.144.14-.324.333-.437.5-.196.12-.339.219-.563.375-.188.11-.391.223-.687.25-.367-.027-.476-.13-.75-.25-.233-.172-.417-.284-.625-.438-.163-.114-.33-.34-.438-.5-.338-.084-.553-.05-.75.125a1.654 1.654 0 0 1-.437.438c-.102.05-.273.199-.375.25",
    strokeWidth: 0.2339,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.024 102.811c.08.033.372.237.5.313.08.263.208.407.25.687.068.271.063.57.063.875-.069.32-.202.556-.313.813-.197.134-.297.233-.563.375-.249.033-.493.062-.812.062-.19.064-.562.094-.75 0-.279-.038-.486-.15-.688-.25-.23-.13-.373-.254-.625-.375-.122-.18-.313-.346-.5-.563-.155-.21-.27-.328-.375-.562.093.267.233.5.313.75.142.266.224.36.25.688.087.26.062.576.062.875-.027.203-.042.583-.125.75v.187",
    strokeWidth: 0.1878,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.948 146.446v.125c0-.337-.008-.166.125.5.236.292.789.374 1.25.25.404-.334.392-.587 1.125-.75.708.05.978.256 1.375.5.47.235.688.354 1 .875.155.424.242.711-.25.875-.39.277-.855.43-1.375.5-.577 0-.994-.068-1.25.25-.397.411-.375.655-.375 1.375-.133.222-.16.879-.25 1.125-.347.165-.551.25-1.125.25-.135-.386-.285-1.084-.375-1.5-.098-.45-.128-1.076-.375-1.375a3.316 3.316 0 0 1-.875-.875c-.153-.215-.445-.393-.75-.5.49.25.56.52.625 1.125-.431.216-.546.367-1.25.375-.692-.058-.859-.234-1.125-.625-.048.627-.249.837-.375 1.375-.257.378-.366.766-.625 1.25.11.602.347.633.375 1.375.162.487.145.957.5 1.25.158.194.277.232.625.25-.724 0-1.145-.078-1.625-.375-.37-.228-.651-.512-1-.75-.443-.32-.99-.617-1.5-.75-.578 0-.994-.068-1.25.25-.354.253-.592.69-.75 1.25-.116.649-.16 1.081.125 1.5.211.482.26.67 0 1.25-.29.407-.724.455-1.375.625a4.498 4.498 0 0 1-1.25-.25",
    strokeWidth: 0.24580000000000002,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: 1.311,
    transform: "matrix(-.2 0 0 .2 145.2 -13.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.5 359.64c0-165.27 7.937-299.41 17.717-299.41 9.78 0 17.716 134.13 17.716 299.41H531.5z",
    transform: "matrix(1.4 -.7 .5 .9 -716.8 541.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.5 359.64c0-165.27 7.937-299.41 17.717-299.41 9.78 0 17.716 134.13 17.716 299.41",
    transform: "matrix(1.1 -.6 .4 .9 -554.8 471.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.39 301.18c.19 18.908 0 40.188 0 60.236h-28.347c0-20.048-.19-41.328 0-60.236h28.347z",
    transform: "matrix(1.4 -.7 .5 .9 -716.7 541.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.84 304.72c.19 18.908 0 33.102 0 53.15h-21.26c0-20.048-.19-34.242 0-53.15h21.26z",
    transform: "matrix(1.4 -.7 .5 .9 -716.7 541.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.4 -.7 .5 .9 -716.7 541.4)",
    fill: "#fff",
    d: "M542.13 311.81h14.173v38.976H542.13zm0 0l14.173 38.976m-14.173.004l14.173-38.976M542.13 113.39h14.173"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#ef0000",
    transform: "matrix(1.6 .5 -.4 1.6 -734.9 -170.8)",
    cx: 545.67,
    rx: 3.543,
    cy: 92.126,
    ry: 3.543
  })), /*#__PURE__*/React.createElement("path", {
    d: "M538.58 531.5c1.717 166.56 24.803 201.97 3.543 201.97s-31.89-92.07-31.89-205.51 14.173-205.51 35.433-205.51-8.913 31.91-7.086 209.06z",
    fillRule: "evenodd",
    transform: "matrix(.3 -.1 .2 .2 -181.5 60.8)",
    strokeWidth: 1.311,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.234 141.806l-12.047 3.543c11.338 12.047 24.094 17.008 27.638 14.882 3.543-2.126-6.378-7.087-15.59-18.425z",
    fillRule: "evenodd",
    strokeWidth: 0.24580000000000002,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.054 148.58l-10.185 2.948c11.338 12.047 22.554 15.477 25.456 14.003 2.918-1.474-6.058-5.613-15.27-16.951z",
    fillRule: "evenodd",
    strokeWidth: 0.254,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.713 83.123c.019.127.075.707.125.938 0 .318.029.563.063.812.08.218.065.42.312.5.17.263.276.331.5.438.153.132.384.264.625.375.25.107.477.121.75.062.219-.152.38-.31.563-.437.042-.198.082-.49.124-.688a3.258 3.258 0 0 0-.125.813c.024.312.127.448.25.687M78.438 87.173l.063-.063c-.149.149-.088.078.25-.124.242-.125.501-.191.812-.25h.875c.34 0 .57.05.813.124.176.177.439.277.624.438.191.13.273.283.376.5.17.17.28.433.437.563.07.286.214.277.313.5-.295.022-.532.062-.688.25-.26.134.218-.132.313-.25.204-.062.257-.126.562-.126.285-.09.458.074.75.126.17.098.218.124.438.124M81.213 90.086c.127.008.708.115.938 0 .255-.07.406-.204.562-.437.077-.17 0 .3 0 .5.029.368.137.37.313.625.181.116.372.28.562.375.158.136.352.228.563.312.19.09.41.181.562.313.21.149.19.327.313.562-.024.306-.073.479-.25.625-.074.211-.24.42-.375.563-.155.287-.326.422.062.5.214.09.333.02.563 0M85.063 94.373c.154-.039.698-.221.938-.313h.874c.34.027.404.126.688.25.183.188.31.317.563.438.134.174.395.468.5.688.074.213.125.502.125.812-.005.365-.1.427-.125.75-.07.269-.184.515-.375.75-.027.08-.046.099-.125.125",
    strokeWidth: 0.1751,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.713 119.998c.037 0 .12.202.25.375.283.29.32.313.75.313.388-.015.352-.154.625-.25.129-.201.29-.36.438-.626.1-.163.188-.412.312-.562.114-.185.256-.325.375-.5.117-.05.162-.098.313-.125-.36.058-.392.187-.625.375-.11.178-.219.363-.313.563-.036.267-.121.477-.125.812 0 .346.002.587.125.875.147.154.256.314.438.438.143.14.324.333.437.5.196.12.339.219.563.375.188.11.391.223.687.25.367-.027.476-.13.75-.25.233-.172.417-.284.625-.438.163-.114.33-.34.438-.5.338-.084.553-.05.75.125a1.654 1.654 0 0 1 .437.438c.102.05.273.199.375.25",
    strokeWidth: 0.2339,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.376 102.211c-.08.033-.372.237-.5.313-.08.263-.208.407-.25.687-.068.271-.063.57-.063.875.069.32.202.556.313.813.197.134.297.233.563.375.249.033.494.062.812.062.19.064.562.094.75 0 .279-.038.486-.15.688-.25.23-.13.373-.254.625-.375.122-.18.313-.346.5-.562.155-.211.27-.33.375-.563-.093.267-.233.5-.313.75-.142.266-.224.36-.25.688-.087.26-.062.576-.062.875.027.203.042.583.125.75v.187",
    strokeWidth: 0.1878,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.352 145.746v.125c0-.337.008-.166-.125.5-.236.292-.789.374-1.25.25-.404-.334-.392-.587-1.125-.75-.708.05-.978.256-1.375.5-.47.235-.688.354-1 .875-.155.424-.242.711.25.875.39.277.855.43 1.375.5.577 0 .994-.068 1.25.25.397.411.375.655.375 1.375.133.222.16.879.25 1.125.347.165.551.25 1.125.25.135-.386.285-1.084.375-1.5.098-.45.128-1.076.375-1.375a3.316 3.316 0 0 1 .875-.875c.153-.215.445-.393.75-.5-.49.25-.56.52-.625 1.125.431.216.546.367 1.25.375.692-.058.859-.234 1.125-.625.048.627.249.837.375 1.375.257.378.366.766.625 1.25-.11.602-.347.633-.375 1.375-.162.487-.145.957-.5 1.25-.158.194-.277.232-.625.25.724 0 1.145-.078 1.625-.375.37-.228.651-.512 1-.75.443-.32.99-.617 1.5-.75.578 0 .994-.068 1.25.25.354.253.592.69.75 1.25.116.649.16 1.081-.125 1.5-.211.482-.26.67 0 1.25.29.407.724.455 1.375.625a4.498 4.498 0 0 0 1.25-.25",
    strokeWidth: 0.24580000000000002,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.311,
    fillRule: "evenodd",
    transform: "matrix(.2 0 0 .2 19.1 -14.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.5 359.64c0-165.27 7.937-299.41 17.717-299.41 9.78 0 17.716 134.13 17.716 299.41H531.5z",
    transform: "matrix(1.4 -.7 .5 .9 -716.8 541.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.5 359.64c0-165.27 7.937-299.41 17.717-299.41 9.78 0 17.716 134.13 17.716 299.41",
    transform: "matrix(1.1 -.6 .4 .9 -554.8 471.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.39 301.18c.19 18.908 0 40.188 0 60.236h-28.347c0-20.048-.19-41.328 0-60.236h28.347z",
    transform: "matrix(1.4 -.7 .5 .9 -716.7 541.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.84 304.72c.19 18.908 0 33.102 0 53.15h-21.26c0-20.048-.19-34.242 0-53.15h21.26z",
    transform: "matrix(1.4 -.7 .5 .9 -716.7 541.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.4 -.7 .5 .9 -716.7 541.4)",
    fill: "#fff",
    d: "M542.13 311.81h14.173v38.976H542.13zm0 0l14.173 38.976m-14.173.004l14.173-38.976M542.13 113.39h14.173"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#ef0000",
    transform: "matrix(1.6 .5 -.4 1.6 -734.9 -170.8)",
    cx: 545.67,
    rx: 3.543,
    cy: 92.126,
    ry: 3.543
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    fill: "#fff",
    transform: "matrix(.2 0 0 .2 19.1 -14.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.61 396.85c0 124.02.49 170.76-5.62 177.17-5.79 6.857-167.12 0-167.12 35.433s132.87 70.867 172.74 70.866c53.15 0 79.723-35.434 79.723-106.3V396.85H305.61z",
    transform: "matrix(1.3 0 0 1 -141.7 0)",
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.75 432.25v17.717c35.433 5.906 70.866 5.906 106.3 0V432.25c-35.433 5.906-70.866 5.906-106.3 0zM265.75 396.85v17.717c35.433 5.906 70.866 5.906 106.3 0V396.85c-35.433 5.906-70.866 5.906-106.3 0z",
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.75 414.55v17.717c35.433 5.906 70.866 5.906 106.3 0V414.55c-35.433 5.906-70.866 5.906-106.3 0zM265.75 450.05v17.717c35.433 5.906 70.866 5.906 106.3 0V450.05c-35.433 5.906-70.866 5.906-106.3 0z",
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.5 0 0 .1 130.5 394.3)",
    cx: 256.89,
    rx: 8.858,
    cy: 210.83,
    ry: 26.575,
    strokeWidth: 4.388
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.5 0 0 .1 130.5 391.1)",
    cx: 292.32,
    rx: 8.858,
    cy: 246.26,
    ry: 26.575,
    strokeWidth: 4.388
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.5 0 0 .1 130.5 390.5)",
    cx: 327.76,
    rx: 8.858,
    cy: 263.98,
    ry: 26.575,
    strokeWidth: 4.388
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.5 0 0 .1 130.5 390.5)",
    cx: 363.19,
    rx: 8.858,
    cy: 263.98,
    ry: 26.575,
    strokeWidth: 4.388
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.5 0 0 .1 130.5 391.1)",
    cx: 398.62,
    rx: 8.858,
    cy: 246.26,
    ry: 26.575,
    strokeWidth: 4.388
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.5 0 0 .1 130.5 394.3)",
    cx: 434.06,
    rx: 8.858,
    cy: 210.83,
    ry: 26.575,
    strokeWidth: 4.388
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.75 485.43l106.3 95.67m-95.67-95.67l95.67 85.04m-81.5-81.49l81.496 70.866M301.18 488.98l70.866 60.237M311.81 488.98l60.236 49.607M322.44 488.98l49.606 38.977M333.07 488.98l38.976 28.347M343.7 488.98l28.346 21.26m-17.716-21.26l17.716 14.174m-7.086-14.174l7.086 7.087m-106.296-.007l106.3 95.67m0-106.3l-116.93 106.3m106.3-106.3l-102.76 92.126m88.59-88.576l-81.496 70.866m70.866-70.866l-70.866 60.237m60.236-60.237l-60.236 49.607m49.606-49.607l-49.606 38.977m38.976-38.977l-38.976 28.347M294.1 488.98l-28.346 21.26m17.716-21.26l-17.716 14.174m7.086-14.174l-7.086 7.087m106.296-.007l-116.93 106.3m116.93-95.67l-116.93 106.3m116.93-95.67l-116.93 106.3m116.93-95.67l-116.93 106.3m116.93-95.67l-116.93 106.3m116.93-95.67l-116.93 106.3m116.93-95.67l-116.93 106.3m116.93-95.67l-116.93 106.3m116.93-95.67l-109.84 99.21m109.84-88.58l-99.212 88.583M368.5 605.9l-77.953 70.866m74.413-56.686l-63.78 56.693m56.69-38.983l-31.89 28.346M265.75 506.69l102.76 92.126m-102.763-81.49l102.76 92.127m-102.76-81.496l99.213 88.583m-99.213-77.953l99.213 88.583m-99.207-77.957l95.67 85.04m-99.22-77.95l95.67 85.04m-95.67-74.41l88.584 77.953m-92.124-70.873l88.583 77.953m-92.132-70.863l85.04 74.41m-85.04-63.783l81.495 70.865m-81.497-60.235l70.866 63.78M265.75 467.75v17.717c35.433 5.906 70.866 5.906 106.3 0V467.75c-35.433 5.906-70.866 5.906-106.3 0zM255.114 612.99l63.78 56.692m-63.78-46.062l56.693 49.606m-56.694-38.976l49.606 42.52m-49.606-31.89l35.434 31.89m-35.434-21.26l28.347 24.804m-28.347-14.174l17.716 14.173",
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.5 0 0 .1 130.5 447.5)",
    cx: 256.89,
    rx: 8.858,
    cy: 210.83,
    ry: 26.575,
    strokeWidth: 4.388
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.5 0 0 .1 130.5 444.3)",
    cx: 292.32,
    rx: 8.858,
    cy: 246.26,
    ry: 26.575,
    strokeWidth: 4.388
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.5 0 0 .1 130.5 443.6)",
    cx: 327.76,
    rx: 8.858,
    cy: 263.98,
    ry: 26.575,
    strokeWidth: 4.388
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.5 0 0 .1 130.5 443.6)",
    cx: 363.19,
    rx: 8.858,
    cy: 263.98,
    ry: 26.575,
    strokeWidth: 4.388
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.5 0 0 .1 130.5 444.3)",
    cx: 398.62,
    rx: 8.858,
    cy: 246.26,
    ry: 26.575,
    strokeWidth: 4.388
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.5 0 0 .1 130.5 447.5)",
    cx: 434.06,
    rx: 8.858,
    cy: 210.83,
    ry: 26.575,
    strokeWidth: 4.388
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.39 651.97l127.55-74.41m-134.637 70.867l120.47-70.87M102.76 641.34l109.84-63.78M99.217 634.255l95.67-56.693m-102.76 49.6l88.583-49.606m-85.043 38.983l60.236-35.433m-63.776 28.35l46.063-28.346m-46.066 17.71l31.89-17.718m0 74.407l120.47-70.86m-109.837 74.407l113.38-67.32M145.28 662.6l106.3-63.78m-95.67 67.324l88.583-53.15m-74.41 53.142l77.952-46.063m-67.322 49.607l67.323-38.976m-56.7 42.523l53.15-31.89m-38.976 31.896l42.52-24.803m-28.35 28.347l28.347-17.717m-14.164 17.713l17.717-10.63M258.65 574.05h-17.717c-5.906 35.433-5.906 70.866 0 106.3h17.717c-5.906-35.433-5.906-70.866 0-106.3zM49.61 623.624l42.52-35.433M49.61 598.8l42.52 42.52",
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.15 387.99l5.595 26.575c35.433 5.906 65.27 5.906 100.7 0l11.19-26.575c-35.433 5.906-82.056 5.906-117.49 0z",
    transform: "matrix(0 .6 -.8 0 423.8 416.3)",
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.66 350.79v-17.865c-10.63.15-17.716-10.48-17.717-21.26l-35.432.15c0 10.63-7.086 21.26-17.716 21.26v17.715h70.866z",
    transform: "matrix(1.5 0 0 1 -15.6 53.1)",
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.356,
    d: "M296.09 343.7h45.506v21.26H296.09zm3.79-21.26h37.922v21.26H299.88zm0-21.26h37.922v21.26H299.88zm3.79-28.35h30.337v28.346H303.67z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.413,
    d: "M302.36 248.03h32.953v24.803H302.36z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(75.4 63.8)",
    cx: 237.4,
    rx: 42.52,
    cy: 161.22,
    ry: 33.661,
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.06 223.25c0 9.29 10.63 24.803 10.63 24.803-7.696 6.093-20.154 10.63-31.89 10.63s-26.348-2.528-31.89-10.63c0 0 10.63-15.512 10.63-24.803s-10.63-21.26-10.63-21.26c7.697-6.093 20.155-10.63 31.89-10.63 11.736 0 24.194 4.537 31.89 10.63 0 0-10.63 11.97-10.63 21.26z",
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.98 223.25c0 9.29 10.63 28.346 10.63 28.346-7.696 6.093-13.068 7.087-24.803 7.087s-19.262 1.015-24.803-7.087c0 0 10.63-19.055 10.63-28.346s-10.63-24.803-10.63-24.803c7.696-6.093 13.067-7.087 24.803-7.087 11.735 0 17.107.994 24.803 7.087 0 0-10.63 15.512-10.63 24.803z",
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(75.4 60.2)",
    cx: 194.88,
    rx: 10.63,
    cy: 166.54,
    ry: 10.63,
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(163.2 60.2)",
    cx: 194.88,
    rx: 10.63,
    cy: 166.54,
    ry: 10.63,
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(119.3 60.2)",
    cx: 194.88,
    rx: 10.63,
    cy: 166.54,
    ry: 10.63,
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(119.3 24.8)",
    cx: 194.88,
    rx: 10.63,
    cy: 166.54,
    ry: 10.63,
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1.1 0 0 1 79.9 226.8)",
    cx: 194.88,
    rx: 10.63,
    cy: 166.54,
    ry: 10.63,
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1.1 0 0 1 140.6 226.8)",
    cx: 194.88,
    rx: 10.63,
    cy: 166.54,
    ry: 10.63,
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6 311.81h49.607l-24.803 31.89-24.804-31.89z",
    transform: "matrix(1.1 0 0 1 64.8 53.1)",
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1.4 0 0 1.3 40.7 167.7)",
    cx: 194.88,
    rx: 10.63,
    cy: 166.54,
    ry: 10.63,
    strokeWidth: 1.311
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "matrix(.2 0 0 .2 18.8 -19.1)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 4.349,
    ry: 3.687,
    height: 21.26,
    width: 81.496,
    y: 524.41,
    x: 262.2,
    strokeWidth: 1.229
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.51 506.69c-9.814 0-17.716 8.26-17.716 18.52v16.11c0 10.26 7.902 18.52 17.716 18.52 9.815 0 17.717-8.26 17.717-18.52v-16.11c0-10.26-7.902-18.52-17.717-18.52zm0 7.087c-5.888 0-10.63 6.608-10.63 14.816v9.345c0 8.208 4.742 14.816 10.63 14.816 5.89 0 10.63-6.608 10.63-14.816v-9.345c0-8.208-4.74-14.816-10.63-14.816zm-92.13-3.537c-5.888 0-10.63 6.608-10.63 14.816v16.432c0 8.208 4.742 14.816 10.63 14.816 5.89 0 10.63-6.608 10.63-14.816v-16.432c0-8.208-4.74-14.816-10.63-14.816zm0-7.087c-9.814 0-17.716 8.26-17.716 18.52v23.197c0 10.26 7.902 18.52 17.716 18.52 9.815 0 17.717-8.26 17.717-18.52v-23.198c0-10.26-7.902-18.52-17.717-18.52z",
    strokeWidth: 1.229
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.03 517.32c-5.888 0-10.63 6.608-10.63 14.816V536c0 8.208 4.74 14.816 10.63 14.816 5.888 0 10.63-6.608 10.63-14.816v-3.864c0-8.208-4.74-14.816-10.63-14.816zm0-7.087c-9.814 0-17.716 8.26-17.716 18.52v10.63c0 10.26 7.9 18.52 17.715 18.52 9.814 0 17.716-8.26 17.716-18.52v-10.63c0-10.26-7.9-18.52-17.716-18.52z",
    strokeWidth: 1.229
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 237.4c-5.888 0-10.63 6.608-10.63 14.816v16.432c0 8.208 4.742 14.816 10.63 14.816 5.89 0 10.63-6.608 10.63-14.816v-16.432c0-8.208-4.74-14.816-10.63-14.816zm0-7.087c-9.814 0-17.716 8.26-17.716 18.52v23.197c0 10.26 7.902 18.52 17.716 18.52 9.815 0 17.717-8.26 17.717-18.52v-23.198c0-10.26-7.902-18.52-17.717-18.52z",
    transform: "matrix(1.8 0 0 1.1 -655.5 242.2)",
    strokeWidth: 0.867
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 237.4c-5.888 0-10.63 6.608-10.63 14.816v16.432c0 8.208 4.742 14.816 10.63 14.816 5.89 0 10.63-6.608 10.63-14.816v-16.432c0-8.208-4.74-14.816-10.63-14.816zm0-7.087c-9.814 0-17.716 8.26-17.716 18.52v23.197c0 10.26 7.902 18.52 17.716 18.52 9.815 0 17.717-8.26 17.717-18.52v-23.198c0-10.26-7.902-18.52-17.717-18.52z",
    transform: "matrix(1.8 0 0 1.1 -425.2 245.7)",
    strokeWidth: 0.867
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 2.269,
    ry: 3.687,
    height: 21.26,
    width: 42.52,
    y: 524.41,
    x: 375.59,
    strokeWidth: 1.229
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 1.324,
    ry: 4.916,
    height: 28.346,
    width: 24.803,
    y: 520.87,
    x: 336.61,
    strokeWidth: 1.229
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 1.324,
    ry: 4.916,
    height: 28.346,
    width: 24.803,
    y: 520.87,
    x: 219.69,
    strokeWidth: 1.229
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 2.647,
    ry: 6.145,
    height: 35.433,
    width: 49.606,
    y: 517.32,
    x: 141.73,
    strokeWidth: 1.229
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 2.458,
    ry: 6.145,
    height: 35.433,
    width: 46.063,
    y: 520.87,
    x: 450,
    strokeWidth: 1.229
  }))))));
};
export default SvgOm;